import React from 'react';
import { PropTypes as PT } from 'prop-types';
import SVG from 'react-inlinesvg';
import caretDownIcon from '@lifesize/ux-assets/vectors/svgIcons/caret-down.svg';
import DropdownComp from 'components/Dropdown/Dropdown';
import classes from 'components/Contacts/Contacts.module.scss';

const ContactsFilter = (props) => {
  const { handleFilterChange, options, selected, type } = props;

  const getSelectedValue = () =>
    options.find(x => x.key === selected).label;

  const renderButton = () =>
    <div className={classes.contactFilterDropdown} data-testid={`${type}-filter`}>
      {getSelectedValue()}
      <SVG src={caretDownIcon} data-testid="caretDownIcon" />
    </div>;

  const renderMenu = () => (
    <div className={classes.dropdownAutoWidth}>
      {
        options.map(option =>
          <div key={option.key} className={classes.filterItem}>
            <button
              className={classes.filterButton}
              onClick={() => handleFilterChange(type, option.key)}
              data-testid={option.dataTestId}
            >
              {option.key === selected ? <b>{option.label}</b> : option.label}
            </button>
          </div>
        )
      }
    </div>
  );

  return (
    <div>
      <DropdownComp
        buttonComponent={renderButton()}
        menuComponent={renderMenu()}
        menuNoLeft
        noCaret
      />
    </div>
  );
};

ContactsFilter.propTypes = {
  handleFilterChange: PT.func.isRequired,
  options: PT.array.isRequired,
  selected: PT.string,
  type: PT.string.isRequired
};

export default ContactsFilter;
